// extracted by mini-css-extract-plugin
export default {"form":"ChangeLoginData_form__1yXji"};